import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-table-items',
  templateUrl: './table-items.component.html',
  styleUrls: ['./table-items.component.scss']
})
export class TableItemsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
